import { TABLA_DETALLE_POR_CONDICION_LINEA_5 } from '../../../../../config/tables'
import { TablaDetallePorCondicionLinea5Service } from '../../../../../models/movimiento/distribucionDetallePorCondicion/Tabla_detalle_por_condicionl_linea_5'
import { COLUMNS_DETALLE_POR_CONDICION_LINEA_5, COLUMNS_DETALLE_POR_CONDICION_LINEA_5_TO_PRINT } from './constantesDetallePorCondicionLinea5'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DETALLE_POR_CONDICION_LINEA_5
    })
    const promiseTablaDetallePorCondicionLinea5 = TablaDetallePorCondicionLinea5Service.getDataTablaDetallePorCondicionLinea5()
    const promiseTablaDetallePorCondicionLinea5Total = TablaDetallePorCondicionLinea5Service.getDataTablaDetallePorCondicionLinea5Total()
    Promise.all([promiseTablaDetallePorCondicionLinea5, promiseTablaDetallePorCondicionLinea5Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Condición Sector 5 Manipuleo',
        dataCombinada,
        COLUMNS_DETALLE_POR_CONDICION_LINEA_5_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DETALLE_POR_CONDICION_LINEA_5,
          data: dataCombinada,
          title: `Condición Sector 5 Manipuleo`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, print: false, pagination: false }
        },
        id: TABLA_DETALLE_POR_CONDICION_LINEA_5
      })
    }
  }
}
